import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import AppConfig from '../../appConfig';
import SecondaryNavbar from './secondaryNavbar';
import { getRelativePath, getMajorMenuName } from '../../common/utils';
import { connect } from 'react-redux';
import NavbarAuthButtons from './NavbarAuthButtons';

class Navbar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            secondaryNavbar: this.showSecondaryNavbar(),
            showSidebarMenu: false
        }
    }

    showSecondaryNavbar() {
        const majorMenu = getMajorMenuName(getRelativePath(this.props.location.pathname));

        switch (majorMenu) {
            case 'admin': return true;
            default: return false;
        }
    }

    active = {
        color: "white"
    };

    LinkClick = (linkName) => e => {
        switch (linkName) {
            case 'admin':
                this.setState({ secondaryNavbar: true });
                break;
            default:
                this.setState({ secondaryNavbar: false });
                this.props.showSidebarMenu(false);

                break;
        }
    };

    render() {
        const { secondaryNavbar } = this.state;
        return (
            <>
                <div id="header" className='header-section dock-menu'>
                    <nav className="navbar navbar-expand-md navbar-dark bg-dark ir-navbar fixed-top" style={{ justifyContent: 'flex-start', zIndex: 1030 }}>
                    <button className="pull-left navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <a className="navbar-brand" href={AppConfig.baseUrl}><img alt='Insight Results' src={'http://portal.insightresults.com/logo.png'} /></a>
                        <div className="navbar-collapse collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav mr-auto" style={{ backgroundColor: '#0079BF' }}>
                                <li className={"nav-item"} data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <NavLink exact to={AppConfig.baseUrl} className={"nav-link"} activeStyle={this.active} onClick={this.LinkClick('home')} >Home</NavLink>
                                </li>
                                <li className={"nav-item"} data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <NavLink to={AppConfig.baseUrl + 'Employees'} className={"nav-link"} activeStyle={this.active} onClick={this.LinkClick('employees')}>Employees</NavLink>
                                </li>
                                <li className={"nav-item"}>
                                    <NavLink to={AppConfig.baseUrl + 'Projects'} className={"nav-link"} activeStyle={this.active} onClick={this.LinkClick('projects')}>Projects</NavLink>
                                </li>
                                {this.props.dashboardData.userRole == 'Admin' && (
                                    <li className={"nav-item"} data-toggle="collapse" data-target=".navbar-collapse.show">
                                        <NavLink to={AppConfig.baseUrl + 'Admin'} className={"nav-link"} activeStyle={this.active} onClick={this.LinkClick('admin')}>Admin</NavLink>
                                    </li>
                                )}
                            </ul>
                            {AppConfig.auth0.useAuth0 && (
                                <ul className="navbar-nav ml-auto" style={{ backgroundColor: 'transparent' }}>
                                    <li className="nav-item">
                                        <NavbarAuthButtons />
                                    </li>
                                </ul>
                            )}
                        </div>
                    </nav>
                </div>
                {secondaryNavbar &&
                    <SecondaryNavbar showSidebarMenu={this.props.showSidebarMenu} sidebarMenu={this.props.sidebarMenu}
                        toggleSidebar={this.props.toggleSidebar} />
                }
            </>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        dashboardData: state.dashboardData,
    }
}
export default connect(mapStateToProps)(Navbar);
